// extracted by mini-css-extract-plugin
export default {"container":"ErrorState_container__Hte8A","body":"ErrorState_body__mXt-h","action":"ErrorState_action__t4HTZ"};